import { API, ManagementAPI } from '../../api';

export const store = {
  getAuth: () => {
    return API.TOKEN || ManagementAPI.TOKEN;
  },
  setAuth: (token: string) => {
    API.TOKEN = token;
    ManagementAPI.TOKEN = token;
  },
  setHeaders: (headers: Record<string, string>) => {
    API.HEADERS = headers;
    ManagementAPI.HEADERS = headers;
  },
  clearAuth: () => {
    API.TOKEN = '';
    ManagementAPI.TOKEN = '';
  },
};
